(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate-manual/assets/javascript/pages/home/components/info.js') >= 0) return;  svs.modules.push('/modules/tickets-validate-manual/assets/javascript/pages/home/components/info.js');
"use strict";

const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  GridCol = _svs$ui$ReactGrid.GridCol,
  GridRow = _svs$ui$ReactGrid.GridRow;
const ContextualAnchor = svs.ticketsValidateManual.components.ContextualAnchor;
const ACCOUNT_INFO_TITLE = 'Spelkonto';
const ACCOUNT_INFO_TEXTS = ['När du vinner på en lott eller ett annat spel hos Svenska Spel sätts dina pengar in på ditt personliga spelkonto. '.concat('Vinsten kan sedan tas ut eller användas för att köpa nya lotter digitalt eller spela andra spel.'), 'Spelkontot behövs för att vi ska kunna säkerställa din identitet och att du är över 18 år gammal, vilket är ett krav för att du ska få spela.'];
setGlobal('svs.ticketsValidateManual.pages.home.components.Info', () => React.createElement(GridRow, null, React.createElement(GridCol, {
  className: "tickets-validate-manual-grid",
  sm: 12
}, React.createElement("h1", {
  className: "h1"
}, "R\xE4tta din fysiska lott"), React.createElement("p", {
  className: "p"
}, "F\xF6r att r\xE4tta och l\xF6sa in eventuell vinst beh\xF6ver du ha ett", ' ', React.createElement(ContextualAnchor, {
  texts: ACCOUNT_INFO_TEXTS,
  title: ACCOUNT_INFO_TITLE
}, "spelkonto"), " hos Svenska Spel."), React.createElement("h4", {
  className: "h4"
}, "\xD6ppna kameraappen p\xE5 din telefon och", React.createElement("br", null), "skanna qr-koden p\xE5 lotten."), React.createElement("img", {
  alt: "QR-kod p\xE5 baksidan av en lott",
  className: "qr-code-img w100 padding-h-2",
  src: "".concat(svs.core.config.data.svsconfig.cdn, "/images/tickets-validate-manual/qr-code.png")
}), React.createElement("h4", {
  className: "h4"
}, "... eller skriv in sifferserien fr\xE5n din lott. Den best\xE5r av", React.createElement("br", null), "27 siffror och finns p\xE5 lottens baksida."))));

 })(window);